import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

function CopyableValue({ label, value }) {
  const handleCopy = () => {
    if (value) navigator.clipboard.writeText(value)
  }
  return (
    <Box sx={{ mb: 1.5 }}>
      {label && (
        <Typography sx={{ fontSize: '0.72rem', fontFamily: 'AtlasGroteskRegular', color: '#888', fontWeight: 600, mb: 0.25 }}>
          {label}
        </Typography>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626' }}>
          {value || '—'}
        </Typography>
        {value && (
          <Tooltip title='Copy'>
            <IconButton size='small' onClick={handleCopy} sx={{ p: 0.25 }}>
              <ContentCopyIcon sx={{ fontSize: 13, color: '#bbb' }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  )
}
CopyableValue.propTypes = { label: PropTypes.string, value: PropTypes.string }

function ShippingDetailsCardV2({ orderDetail }) {
  if (!orderDetail) return null
  return (
    <Box sx={{
      border: '1px solid #e7e7e7',
      borderRadius: 2,
      p: 2.5,
      backgroundColor: '#fff',
      height: '100%',
    }}>
      <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '0.95rem', color: '#262626', fontWeight: 700, mb: 2 }}>
        Shipping Details
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
        <Box>
          <CopyableValue label='Ship-to Name' value={orderDetail.shipToName} />
          <CopyableValue value={orderDetail.shipToAccountNumber} />
        </Box>
        <Box>
          <CopyableValue label='Contact' value={orderDetail.shipToContact} />
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mt: 0.5 }}>
        <Box>
          <Typography sx={{ fontSize: '0.72rem', fontFamily: 'AtlasGroteskRegular', color: '#888', fontWeight: 600, mb: 0.25 }}>
            Ship-to Address
          </Typography>
          <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626' }}>
            {orderDetail.shipToAddress || '—'}
          </Typography>
        </Box>
        <Box>
          <CopyableValue label='PO#' value={orderDetail.dmsOrderNumber} />
          <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626' }}>
            {orderDetail.poDate || ''}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

ShippingDetailsCardV2.propTypes = { orderDetail: PropTypes.object }

export default ShippingDetailsCardV2
